export function useFetchFieldOfLawById(id: MaybeRef<number | undefined>) {
  const enabled = computed(() => Boolean(unref(id)));

  const query = useQuery({
    ...queries().fieldOfLaws.byId(id),
    enabled,
  });

  return { query, enabled };
}
